/* eslint-disable react-hooks/exhaustive-deps */
import { Form } from "react-bootstrap";
import { DropDown, Table, MultiDatePicker, EmptyList } from "components";
import { ResponseHandler } from "components";

const StockTable = ({
    stockRows,
    stockReasons,
    shift,
    b2bOrders,
    showDefaultVal,
    loading,
}) => {
    const columns = [
        {
            Header: "وندور",
            accessor: "vendor_title",
        },
        {
            Header: "نام",
            accessor: "good_title" || "food_title",
            Cell: (props) => {
                return (
                    <span>
                        {props.row.original.food_title ||
                            props.row.original.good_title}
                    </span>
                );
            },
        },
        {
            Header: "تاریخ انقضا",
            accessor: "expiration",
            Cell: (props) => {
                const temp = [...stockRows];
                const element = temp.find((el) => {
                    if (props.row.original.food_title !== undefined) {
                        return el.food_id === props.row.original.food_id;
                    } else {
                        return el.good_id === props.row.original.good_id;
                    }
                });
                return (
                    <MultiDatePicker
                        isPersian
                        placeholder="تاریخ انقضا"
                        date={element.expiration}
                        setDate={(date) => {
                            element.expiration = date;
                        }}
                        calendarPosition="top-left"
                        containerClassName="w-100"
                        inputClassName="w-100 mx-auto"
                    />
                );
            },
        },
        {
            Header: "شیفت",
            accessor: "shift_str",
            Cell: (props) => {
                const temp = [...stockRows];
                const element = temp.find((el) => {
                    if (props.row.original.food_title !== undefined) {
                        return el.food_id === props.row.original.food_id;
                    } else {
                        return el.good_id === props.row.original.good_id;
                    }
                });
                return (
                    <DropDown
                        data={shift}
                        className="w-100 align-self-center"
                        defaultActiveItem={element.shift}
                        getSelectedItem={(data) => {
                            element.shift = data.id;
                            element.shift_str = data.title;
                        }}
                    />
                );
            },
        },
        {
            Header: "علت قرارگیری در دسته",
            accessor: "reason_title",
        },
        {
            Header: "تعداد",
            accessor: "count",
            Cell: (props) => {
                const temp = [...stockRows];
                const element = temp.find((el) => {
                    if (props.row.original.food_title !== undefined) {
                        return el.food_id === props.row.original.food_id;
                    } else {
                        return el.good_id === props.row.original.good_id;
                    }
                });
                const elementCount = b2bOrders?.find(
                    (item) => item?.kitchen_food_id === element?.food_id
                )?.total_sales;
                if (elementCount) element.count = elementCount;

                return (
                    <Form.Control
                        type="number"
                        className="w-50 mx-auto"
                        //value={element.count}
                        defaultValue={!showDefaultVal ? element.count : null} // default value of B2B stock
                        onChange={(event) => {
                            if (event.target.value !== "") {
                                element.count = Number(event.target.value);
                            } else {
                                element.count = null;
                            }
                        }}
                    />
                );
            },
        },
    ];

    return (
        <ResponseHandler loading={loading}>
            <div className="page-template-table-container mt-1">
                {stockRows ? (
                    <Table columns={columns} data={stockRows} />
                ) : (
                    <EmptyList />
                )}
            </div>
        </ResponseHandler>
    );
};

export default StockTable;
